import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { Link } from "react-router-dom";
import { Input, Button } from "antd";
import md5 from "md5";
import mainActions from "../../redux/main/actions";
const LoginForm = () => {
  const { companiesDetails } = useSelector((state) => state.mainReducer);
  const dispatch = useDispatch();
  const { getAdminToken } = mainActions;
  const [company, setCompany] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = () => {
    if (company && username && password) {
      const hashedPassword = md5(password);
      dispatch(getAdminToken(company, username, hashedPassword));
    } else {
      alert("Моля, попълнете всички полета");
    }
  };

  return (
    <div className="login-form-container">
      <div className="company-logo">
        {companiesDetails.length !== 0 ? (
          <Link to="/">
            <img
              alt="Your Company"
              src={`data:image/png;base64, ${companiesDetails?.logo}`}
              className="logo"
            />
          </Link>
        ) : (
          <div className="logo-placeholder"></div>
        )}
      </div>

      <div className="form-container">
        <div className="form">
          <div className="form-group">
            <label htmlFor="company" className="form-label">
              Име на компания
            </label>
            <Input
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Име
            </label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Парола
            </label>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              size="large"
            />
          </div>

          <div className="submit-container">
            <Button
              onClick={handleSubmit}
              type="primary"
              style={{ width: "100%" }}
              className="custom-button"
              size="large"
            >
              Влизане
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
